module.exports = __webpack_public_path__ + "static/media/kellogg.c927ce62.svg";